import { FormError } from "app/containers/types";
import { emailRegex } from "styles/theme/utils";
import { LoginForm } from "../types";

// Both fields are required by the API's UserLoginDto.
const REQUIRED_FIELDS: Array<keyof LoginForm> = ["email", "password"];

export const isLoginFormComplete = (form: LoginForm) =>
  REQUIRED_FIELDS.every((key) => Boolean(form[key].value.trim()));

export function validate(form: LoginForm): Array<FormError> {
  const errors: Array<FormError> = [];
  const email = form.email.value.trim();

  if (!email) {
    errors.push({ name: "email", error: "AUTH.VALIDATION.EMAIL_REQUIRED" });
  } else if (!emailRegex.test(email)) {
    errors.push({ name: "email", error: "AUTH.VALIDATION.EMAIL_INVALID" });
  }
  if (!form.password.value.trim()) {
    errors.push({
      name: "password",
      error: "AUTH.VALIDATION.PASSWORD_REQUIRED",
    });
  }

  return errors;
}
